<template>
  <div v-if="isLoaded">
    <div
      class="content-body"
      v-bind:class="{ fullscreen_expand: isFullscreen }"
    >
      <div class="row match-height">
        <div class="col-xl-12 col-lg-12">
          <div class="card" style="">
            <div class="card-header">
              <h4 class="card-title">Consulta Log de Notas Fiscais</h4>
              <a class="heading-elements-toggle"
                ><i class="fa fa-ellipsis-v font-medium-3"></i
              ></a>
              <div class="heading-elements">
                <ul class="list-inline mb-0">
                  <!-- <li>
                    <a
                      @click="onCreate()"
                      v-b-tooltip
                      title="Cadastrar"
                      v-if="getPermissionFw('veiculo.store')"
                      ><i class="fa fa-plus"></i
                    ></a>
                  </li> -->
                  <li>
                    <a
                      @click="onFilterReset()"
                      v-b-tooltip
                      title="Atualizar listagem"
                      ><i class="ft-rotate-cw"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="expandFullscreenFw()"
                      v-b-tooltip
                      title="Expande a tela"
                      v-if="!isFullscreen"
                      ><i class="ft-maximize"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="expandFullscreenFw()"
                      v-b-tooltip
                      title="Minimiza a tela"
                      v-if="isFullscreen"
                      ><i class="ft-minimize"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="onFilterShowHideFw()"
                      v-b-tooltip.hover.left="'Filtros'"
                      ><i class="fa fa-filter"></i
                    ></a>
                  </li>
                  <!-- <li>
                    <a
                      @click="onActivateDesactivate(1, null, false)"
                      v-b-tooltip
                      title="Ativar Registros"
                      v-if="getPermissionFw('veiculo.status')"
                      ><i class="fa fa-thumbs-o-up"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="onActivateDesactivate(2, null, false)"
                      v-b-tooltip
                      title="Inutilizar Registros"
                      v-if="getPermissionFw('veiculo.status')"
                      ><i class="fa fa-thumbs-o-down"></i
                    ></a>
                  </li> -->
                </ul>
              </div>
            </div>
            <div class="card-content">
              <div class="table-responsive">
                <div v-if="vuetableFilterRow">
                  <vuetable-filterbar :tabela="'veiculo'"> </vuetable-filterbar>
                </div>
                <div class="loadingDataPosition">
                  <div class="loadingData" v-if="loadingData">
                    <div class="loadingDataSpinner">
                      <spinner
                        v-if="loadingData"
                        text-fg-color="#ffffff"
                        message="Carregando..."
                      ></spinner>
                    </div>
                  </div>
                  <vuetable
                    :load-on-start="false"
                    no-data-template="Para retornar algum dado, o usuário deve aplicar os filtros e clicar em filtrar"
                    ref="vuetable"
                    api-url="/api/arquivoedientradalog"
                    :fields="fields"
                    :css="css"
                    :append-params="moreParams"
                    track-by="lisiteval_id"
                    pagination-path=""
                    detail-row-component="ciot-detalhes"
                    @vuetable:cell-clicked="onDetail"
                    @vuetable:load-error="onError"
                    @vuetable:pagination-data="onPaginationData"
                    @vuetable:loaded="onLoaded"
                  >
                    <template slot="usuario_inc" slot-scope="props">
                      <span
                        v-if="props.rowData.usuario_inc.pessoa.pessoa_fisica != null"
                        >{{ props.rowData.usuario_inc.pessoa.pessoa_fisica.nome }}</span
                      >
                      <span
                        v-if="props.rowData.usuario_inc.pessoa.pessoa_juridica != null"
                        >{{ props.rowData.usuario_inc.pessoa.pessoa_juridica.razao_social }}</span
                      >
                    </template>
                    <template slot="status" slot-scope="props">
                      <span
                        class="badge badge-success"
                        v-if="props.rowData.status.valor == 1"
                        >{{ props.rowData.status.descr }}</span
                      >
                      <span
                        class="badge badge-danger"
                        v-if="props.rowData.status.valor == 2"
                        >{{ props.rowData.status.descr }}</span
                      >
                      <span
                        class="badge badge-warning"
                        v-if="props.rowData.status.valor == 3"
                        >{{ props.rowData.status.descr }}</span
                      >
                    </template>
                    <template slot="actions" slot-scope="props">
                      <div class="custom-actions">
                        <a
                          @click="onDetail(props.rowData, null, null)"
                          v-b-tooltip
                          title="Ver detalhes"
                          ><i class="fa fa-plus"></i
                        ></a>
                      </div>
                    </template>
                  </vuetable>
                </div>
                <div>
                  <div class="col-md-12">
                    <div class="pull-left pagination-detail">
                      <vuetable-pagination-info
                        ref="paginationInfo"
                        :css="css.pagination"
                        info-class="pull-left"
                      ></vuetable-pagination-info>
                    </div>
                    <div class="pull-right m-a-0">
                      <vuetable-pagination
                        ref="pagination"
                        :css="css.pagination"
                        @vuetable-pagination:change-page="onChangePage"
                      ></vuetable-pagination>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vuetable from "../components/Vuetable";
import VuetablePagination from "../components/VuetablePagination";
import VuetablePaginationInfo from "../components/VuetablePaginationInfo";
import ConsultaLogNotaFiscalFilterBar from "./ConsultaLogNotaFiscalFilterBar";
// import ConsultaCiotDetalhes from "./ConsultaCiotDetalhes";
import accounting from "accounting";
import moment from "moment";

// Vue.component("ciot-detalhes", ConsultaCiotDetalhes);

export default {
  components: {
    Vuetable,
    VuetablePagination,
    VuetablePaginationInfo,
    // ConsultaCiotDetalhes,
    "vuetable-filterbar": ConsultaLogNotaFiscalFilterBar,
  },
  data() {
    return {
      dataExport: [],
      optionsStatus: [],
      optionsLayout: [],
      helpForm: new Form({ recordCollection: [], status: "" }),
      modal_titulo: "",
      modal_botao: "",
      modal_acao: "",
      loading: false,
      isDisabled: false,
      loadingData: false,
      showModal: false,
      isLoadingExp: false,
      fields: [
        // {
        //   name: "__checkbox",
        //   titleClass: "center aligned",
        //   dataClass: "center aligned",
        // },
        {
          name: "num_doc",
          title: "N° Documento",
        },
        {
          name: "arquivo_edi_entrada.nome_arquivo_original",
          title: "Nome do arquivo original",
        },
        {
          name: "arquivo_edi_entrada.nome_arquivo",
          title: "Nome do arquivo",
        },
        {
          name: "tp_erro.descr",
          title: "Tipo do Erro",
        },
        {
          name: "descr",
          title: "Descrição",
        },
        {
          name: "__slot:usuario_inc",
          title: "Usuário Inc.",
        },
        {
          name: "dt_inc",
          title: "Data de Processamento",
          callback: "formatDate|DD/MM/YYYY HH:mm",
        },
        {
          name: "__slot:status",
          title: "Status",
        },
        // {
        //   name: "__slot:actions", // <----
        //   title: "Ações",
        //   titleClass: "center aligned",
        //   dataClass: "center aligned",
        // },
      ],
      css: {
        loadingClass: "loading",
        ascendingIcon: "glyphicon glyphicon-chevron-up",
        descendingIcon: "glyphicon glyphicon-chevron-down",
        handleIcon: "glyphicon glyphicon-menu-hamburger",
      },
      moreParams: {},
    };
  },
  mounted() {
    this.$events.$on("filter-set", (eventData) => this.onFilterSet(eventData));
    this.$events.$on("filter-reset", (e) => this.onFilterReset());
    this.getLivGeral();
  },
  methods: {
    onDetail(data, field, event) {
      if (data) {
        this.$refs.vuetable.toggleDetailRow(data.ciot_id);
      }
    },
    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
      this.$refs.paginationInfo.setPaginationData(paginationData);
    },
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    formatNumber(value) {
      return accounting.formatNumber(value, 2, ".", ",");
    },
    getLivGeral() {
      this.helpForm
        .get("/api/arquivoedientradalog/jsonlistgeral")
        .then((response) => {
          new ReturnApi(response, this, true, false, false);
          response.status.forEach((obj) => {
            this.optionsStatus.push({ label: obj.descr, value: obj.valor });
          });
          response.layout.forEach((obj) => {
            this.optionsLayout.push({ label: obj.descr, value: obj.lay_id });
          });
        })
        .catch((errors) => {
          new ReturnApi(errors, this);
        });
    },
    onFilterSet(data_filter) {
      this.loadingData = true;
      this.moreParams = {
        num_doc_ini: data_filter.num_doc_ini,
        num_doc_fim: data_filter.num_doc_fim,
        nome_arquivo: data_filter.nome_arquivo,
        nome_arquivo_original: data_filter.nome_arquivo_original,
        dt_ini: data_filter.dt_ini,
        dt_fim: data_filter.dt_fim,
        status: data_filter.status.value,
        layout: data_filter.layout.value,
      };
      Vue.nextTick(() => {
        this.$refs.vuetable.refresh();
      });
    },
    onFilterReset() {
      this.loadingData = true;
      this.moreParams = {};
      Vue.nextTick(() => this.$refs.vuetable.refresh());
    },
    onLoaded: function () {
      this.dataExport = this.$refs.vuetable.tableData;
      this.loadingData = false;
      this.$store.commit("setVuetableFilterButton", false);
    },
    onCreate() {
      this.$refs.veiculoform.onCreate();
    },
    onEdit(data, index) {
      this.id = data.veiculo_id;
      this.$refs.veiculoform.onEdit(data, index, this.id);
    },
    formatDate(value, fmt = "DD/MM/YYYY HH:mm") {
      return value == null ? "" : moment(value, "YYYY/MM/DD HH:mm").format(fmt);
    },
    onActivateDesactivate(action, data, tipo) {
      // Tipo = true = Checkbox
      this.helpForm.status = action;
      if (tipo) {
        this.helpForm.recordCollection = [];
        this.helpForm.recordCollection.push(data.veiculo_id);
      } else {
        this.helpForm.recordCollection = [];
        this.$refs.vuetable.selectedTo.forEach((obj) => {
          this.helpForm.recordCollection.push(obj);
        });
      }
      this.$refs.veiculoform.onActivateDesactivate(this.helpForm);
    },
    onError(response) {
      new ReturnApi(response.response, this, true, true, false);
    },
  },
  computed: {
    vuetableFilterRow: {
      get() {
        return this.$store.state.vuetable.filterRow;
      },
    },
    isLoaded: {
      get() {
        return this.$store.getters.isloaded;
      },
    },
    isFullscreen: {
      get() {
        return this.$store.getters.is_full_screen;
      },
    },
  },
};
</script>